export const OPTION_LISTS = {
    motor: ["Somfy IO", "Somfy IO Mae", "Somfy STD", "Somfy WT Mae", "Selve SMI"],
    side: ["R", "L", "H", "V"],
    kabel: ["0,5 m", "3 m", "5 m", "10 m"],
    infesting: ["1S", "1S Al", "1S Br", "3S", "3S Br", "1N", "1N Al"],
    borring: ["OF (vegg)", "NO (ikke)", "Spesial"],
};

const LABEL_MAP = { motor: "motor", side: "side", "kabel type": "kabel", infesting: "infesting", "borring styr": "borring" };

export const getColumnOptions = (c) =>
    OPTION_LISTS[c.options]
    || OPTION_LISTS[LABEL_MAP[String(c.label || "").trim().toLowerCase()]]
    || (c.key === "motor" ? OPTION_LISTS.motor : null);
